export default "__VITE_PUBLIC_ASSET__c33b245c__"